import { render, staticRenderFns } from "./RmkHistory.vue?vue&type=template&id=791df4e6&scoped=true&"
import script from "./RmkHistory.vue?vue&type=script&lang=js&"
export * from "./RmkHistory.vue?vue&type=script&lang=js&"
import style0 from "./RmkHistory.vue?vue&type=style&index=0&id=791df4e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "791df4e6",
  null
  
)

export default component.exports